import React, { MutableRefObject } from "react"
import router from "next/router"
import { MachinesContextType } from "../../../../_common/machines/machines-context"
import useModal from "../../../../../components/ModalProvider/useModal"
import { delay } from "../../../../_common/promise"
import { SuitesComparisonSelectButtonProps } from "../../../../../components/SuitesComparisonModal/SuitesComparisonSelectButton"
import SelectSuiteButtonAndContinue from "../../../../../components/SelectSuiteButton/SelectSuiteButtonAndContinue"
import { goto } from "../../../../_common/routing"

export const StandardSuitesComparisonButton = (
    machinesContextRef: MutableRefObject<MachinesContextType | undefined>,
): React.FC<Omit<SuitesComparisonSelectButtonProps, "availability">> =>
    function StandardSuitesComparisonButton({ selected, suiteCategory, full }) {
        const { closeAllModals } = useModal()
        const goToNext = () => {
            const state = machinesContextRef.current?.ecommerce.getSnapshot()
            if (!state) return
            return goto(router, state.context.flowVersion.router.routeNextStep(state.context.activeStep, router))
        }
        const onSelect = async () => {
            await closeAllModals("close")
            await delay(300)
            machinesContextRef.current?.ecommerce.send({ type: "SELECT_SUITE_CATEGORY", suiteCategory })
            await delay(300)
            await goToNext()
        }
        return <SelectSuiteButtonAndContinue selected={selected} onClick={onSelect} full={full} />
    }
